const resetPasswordInitialValues = {
  password: "",
  confirmPassword: ""
};

export default resetPasswordInitialValues;
